// extracted by mini-css-extract-plugin
export default {"alternateTitle":"SeriesAlternateTitles-alternateTitle-E0VF1","comment":"SeriesAlternateTitles-comment-gpN28"};